import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IUserLocalStorageState} from "../reducers/user-local-storage.reducer";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getUserLocalStorageState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.userLocalStorage);

export const getUserLocalStorage = createSelector(getUserLocalStorageState,
  (state: IUserLocalStorageState) => {
    return state.userLocalStorageData.userLocalStorageData ? state.userLocalStorageData.userLocalStorageData : {};
  }
);

export const getUserLocalStorageLoading = createSelector(getUserLocalStorageState,
  (state: IUserLocalStorageState) =>
    state.userLocalStorageData.loading
);

export const getUserLocalStorageLoaded = createSelector(getUserLocalStorageState,
  (state: IUserLocalStorageState) =>
    state.userLocalStorageData.loaded
);
